import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AggregatedJobData, isTruthy } from '@shared';
import { filter, map } from 'rxjs/operators';
import {
  getActiveJobsCount,
  getAggregatedMatches,
  getTotalApplicantsCount,
  getTotalDirectPerPhase,
} from '@collections/aggregations';

@Component({
  selector: 'mojo-pipeline-bar-charts',
  styleUrls: ['./pipeline-bar-charts.component.scss'],
  templateUrl: './pipeline-bar-charts.component.html',
})
export class PipelineBarChartsComponent {
  colors = ['#B3DAFC', '#80C2FA', '#4DA9F7', '#2696F6', '#0084F4', '#0071F1', '#0054EC'];

  totalApplicants$ = this.store.select(getTotalApplicantsCount);
  activeJobCount$ = this.store.select(getActiveJobsCount);
  aggregatedJobData$ = this.store
    .select(getAggregatedMatches)
    .pipe(map((data: AggregatedJobData) => ({ ...data, totalDirect: null })));
  barChartData$ = this.store.select(getTotalDirectPerPhase).pipe(
    filter(isTruthy),
    map((elems: any[]) => ({
      title: '',
      widthBar: '4.5',
      maxHeightBar: '11',
      data:
        elems.length > 0
          ? elems.map((elem, idx) => ({
              data: elem.numberOfDirectApplicants,
              labels: [elem.phase],
              color: this.colors[idx],
            }))
          : [],
    })),
  );

  constructor(private readonly store: Store) {}
}
